<div class="editor-comp w-100 h-100 root flex-column" #editorContainer>
  <nw-project-header></nw-project-header>
  <!-- <ng-container [ngSwitch]="projectState$ | async">
    <div *ngSwitchCase="'error'">output</div>
    <div
      *ngSwitchCase="'loading'"
      class="w-100 h-100 flex-row space-around m-1s2"
    >
      Project is being loaded
    </div> -->

  <div class="relative-wrapper">
    <div
      class="project-state-overlay"
      *ngIf="(projectState$ | async) === 'loading'"
    >
      <div class="blink">Project is being loaded</div>
    </div>

    <!-- <ng-container *ngSwitchCase="'loaded'"> -->
    <div class="w-100 h-100 flex-row stretch base-container">
      <div class="flex-column">
        <nw-side-panel></nw-side-panel>
      </div>
      <ng-container *ngIf="!settingsMode">
        <div
          *ngIf="!currentFileID; else fileSelected"
          class="fill-available-width overflow-hidden flex-row space-around h-100"
        >
          <div>Please select a scene</div>
        </div>

        <ng-template #fileSelected>
          <iw-canvas></iw-canvas>
        </ng-template>
      </ng-container>
    </div>
    <div *ngIf="settingsMode">
      <nw-project-settings></nw-project-settings>
    </div>
  </div>
  <!-- </ng-container> -->
  <!-- </ng-container> -->

  <div
    *ngIf="cs.notification"
    class="position-top"
    fxLayout="column"
    fxLayoutAlign=" center"
  >
    <div class="cdk-content">{{ cs.notification }}</div>
  </div>
</div>

<div *ngIf="overlayConfig" class="iw-overlay" (click)="overlayResponse()">
  <div class="layer"></div>
  <div
    [ngSwitch]="overlayConfig.type"
    class="content w-100 h-100 flex-row space-around"
  >
    <nw-overlay-prompt
      *ngSwitchCase="'prompt'"
      (exit)="overlayResponse($event)"
    ></nw-overlay-prompt>

    <nw-color-selector
      *ngSwitchCase="'color-selector'"
      (exit)="overlayResponse($event)"
    ></nw-color-selector>

    <nw-color-palette-edit
      (click)="$event.stopPropagation()"
      *ngSwitchCase="'color-palette'"
      (exit)="overlayResponse($event)"
    ></nw-color-palette-edit>
  </div>
</div>

<nw-ai-panel *ngIf="showAIPanel$ | async"></nw-ai-panel>
